import Message from "./Message";
import { ChatMessage } from "../types/queries";
import { Nullable } from "../../../common/types/nullable";
import { NameIdOption } from "../../../common/types/commonTypes";
import { RefObject } from "react";
import { Virtuoso, VirtuosoHandle } from "react-virtuoso";
import { Box } from "@mui/material";
import LoadingSpinner from "../../../common/components/functional/loadingSpinner/LoadingSpinner";

type Props = {
  participant: Nullable<NameIdOption>;
  virtuosoRef?: RefObject<VirtuosoHandle>;
  messages: ChatMessage[];
  loadMore: () => void;
  loading: boolean;
  loadingMore: boolean;
  compact?: boolean;
};

const Messages = ({
  messages,
  participant,
  virtuosoRef,
  loadMore,
  loading,
  loadingMore,
  compact = false,
}: Props) => {
  return (
    <Virtuoso
      ref={virtuosoRef}
      data={messages}
      // start from the bottom
      initialScrollTop={Number.MAX_SAFE_INTEGER}
      // start from the bottom
      alignToBottom={true}
      // auto scroll to bottom when new messages are added
      followOutput="auto"
      startReached={loadMore}
      itemContent={(_index, message) => (
        <Message
          key={message.id}
          message={message}
          participant={participant as NameIdOption}
          compact={compact}
        />
      )}
      components={{
        Header: () =>
          loadingMore ? (
            <Box
              display="flex"
              gap="16px"
              padding="8px 0px"
              justifyContent="center"
              alignItems="center"
            >
              <LoadingSpinner size={24} />
            </Box>
          ) : null,
        EmptyPlaceholder: () => (loading ? <LoadingSpinner /> : null),
      }}
    />
  );
};

export default Messages;
